<template>
  <div class="flex flex-col gap-5 min-h-screen p-4">
    <!-- Header Section -->
    <div
      class="relative flex flex-col w-full h-min bg-white rounded-lg p-4 gap-5 dark:bg-gray-800 dark:text-gray-200 shadow"
    >
      <nav
        class="w-full flex flex-row portrait:flex-col justify-between portrait:gap-5"
      >
        <div
          class="w-full max-w-fit flex flex-row gap-5 items-center justify-start"
        >
          <button
            @click="goback"
            class="p-3 flex items-center justify-center aspect-square w-fit bg-blue-gray-500/10 hover:bg-blue-gray-500/20 rounded-lg dark:bg-gray-700 dark:hover:bg-gray-600 transition-colors"
          >
            <i class="fa-solid fa-arrow-left text-base dark:text-gray-200"></i>
          </button>
          <h3 class="text-xl font-medium dark:text-gray-200">
            Subscription Plans
          </h3>
        </div>

        <a
          href="#"
          class="w-full landscape:max-w-fit flex gap-2 items-center justify-center px-5 py-3 bg-blue-gray-500/10 rounded-lg text-sm font-medium h-min dark:bg-gray-700 dark:hover:bg-gray-600 dark:text-gray-200 transition-all hover:shadow-md"
        >
          <i class="fa-regular fa-circle-play"></i>
          <span>Watch Video Tutorial</span>
        </a>
      </nav>
    </div>

    <!-- Main Content -->
    <div class="relative flex flex-col w-full h-min">
      <!-- Explanation Section -->
      <div
        v-if="!selectedPlan"
        class="w-full max-w-3xl mx-auto p-4 mb-2 text-center"
      >
        <h4 class="text-lg font-semibold mb-1 dark:text-white">
          Choose the right plan for your business
        </h4>
        <p class="text-gray-600 dark:text-gray-300 text-sm">
          Select a subscription plan that fits your business needs. You can
          upgrade, downgrade, pause, or cancel at any time. Each plan comes with
          its own set of features and support levels.
        </p>
      </div>
      <ViewPlansComponent
        v-if="!selectedPlan"
        @plan-selected="handlePlanSelection"
      />
      <PlanDetailsComponent
        v-else
        :selectedPlan="selectedPlan"
        :walletBalance="walletBalance"
        @back="selectedPlan = null"
        @payment="processPayment"
      />
    </div>
  </div>
</template>

<script>
import ViewPlansComponent from "@/components/viewPlansComponent.vue";
import PlanDetailsComponent from "@/components/planDetailsComponent.vue";
export default {
  name: "ServicePlansView",
  components: {
    ViewPlansComponent,
    PlanDetailsComponent,
  },
  data() {
    return {
      selectedPlan: null,
      walletBalance: 5000,
    };
  },
  computed: {
    plans() {
      return this.$store.getters.servicePlans || [];
    },
  },
  mounted() {
    this.$store.dispatch("fetchServicePlans");
  },
  methods: {
    goback() {
      this.$router.go(-1);
    },
    handlePlanSelection(planId) {
      if (!this.plans || !this.plans.length) return;
      this.selectedPlan = this.plans.find((plan) => plan.id === planId);
    },
    processPayment(paymentDetails) {
      // Handle payment processing here
      console.log("Processing payment:", paymentDetails);
    },
  },
};
</script>
